// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectionGuideSection_wrapper__F7WIC","text":"SelectionGuideSection_text__l3EVc","button":"SelectionGuideSection_button__TH4nF"};